import { createAsyncThunk } from '@reduxjs/toolkit'
import type { TablePaginationConfig } from 'antd/es/table'

import { env } from '@/common/config/env'
import { HttpMethods } from '@/common/constants/http-methods.constants'
import api from '@/common/helpers/api.helpers'
import { buildPaginationQuery } from '@/common/utils/table.utils'
import {
  ILeaseDealBundlesResponse,
  ILeaseDealTemplatesResponse,
} from '@/features/promotions/interfaces/lease-deal-templates.interfaces'
import { IDealPackagePreviewRequest } from '@/features/promotions/interfaces/promotions.interfaces'

const fetchPromotions = createAsyncThunk(
  'promotions/fetchPromotions',
  async (params: { tableParams: TablePaginationConfig; filter?: string }) => {
    const response = await api(
      HttpMethods.GET,
      `${
        buildPaginationQuery(`${env.RESIDEN_API_BASE_URL}/deals/all-deals`, params.tableParams) +
        `&filter=${params.filter}`
      }`,
    )

    return response.data
  },
)

const fetchPromotionsConfigData = createAsyncThunk('promotions/fetchPromotionsConfigData', async () => {
  const response = await api(HttpMethods.GET, `${env.RESIDEN_API_BASE_URL}/deals`)
  return response.data
})

const fetchPromotionsPackagesConfigData = createAsyncThunk('promotions/fetchPromotionsPackagesConfigData', async () => {
  const response = await api(HttpMethods.GET, `${env.RESIDEN_API_BASE_URL}/deals/packages`)
  return response.data
})

const fetchPromotionById = createAsyncThunk('promotions/fetchPromotionById', async (promotionId: number) => {
  const response = await api(HttpMethods.GET, `${env.RESIDEN_API_BASE_URL}/deals/${promotionId}`)
  return response.data[0]
})

const generatePromotion = createAsyncThunk('promotions/generatePromotion', async (data: any) => {
  const response = await api(HttpMethods.POST, `${env.RESIDEN_API_BASE_URL}/deals`, data)
  return response.data
})

const fetchLeaseDealTemplates = createAsyncThunk('promotions/fetchLeaseDealTemplates', async () => {
  const response = await api(HttpMethods.GET, `${env.RESIDEN_API_BASE_URL}/lease-deal-templates`, {})
  return (response.data as ILeaseDealTemplatesResponse).items
})

const fetchLeaseDealBundles = createAsyncThunk('promotions/fetchLeaseDealBundles', async () => {
  const response = await api(HttpMethods.GET, `${env.RESIDEN_API_BASE_URL}/lease-deals-bundles`, {})
  return (response.data as ILeaseDealBundlesResponse).items
})

const previewDealPackage = createAsyncThunk(
  'promotions/previewDealPackage',
  async (payload: IDealPackagePreviewRequest) => {
    const response = await api(HttpMethods.POST, `${env.RESIDEN_API_BASE_URL}/deals/packages`, payload)
    return response.data
  },
)

export const promotionsService = {
  fetchPromotions,
  fetchPromotionsConfigData,
  fetchPromotionsPackagesConfigData,
  generatePromotion,
  fetchPromotionById,
  fetchLeaseDealTemplates,
  fetchLeaseDealBundles,
  previewDealPackage,
}
